import React, { Component } from 'react'
import './App.css'

import logo from './images/logo.svg'


let Logo = () =>


<a href="https://theinitium.com/" className="logo">
    <img src={logo}/>
</a>

export default Logo


/** WEBPACK FOOTER **
 ** ./src/Logo.js
 **/